import Button from "../../../Components/Button/Button";
import EmtPortalFooter from "../../../Components/LpComponents/Reactportal/PortalFooter";
import "./RCDetailsModal.scss";

function RCDetailsModal({ onClose, RC_Data }) {
  // function replaceEvenPositionsWithX(inputString, placeholder = "X") {
  //   const result = inputString.split("");

  //   for (let i = 1; i < result.length; i += 2) {
  //     result[i] = placeholder;
  //   }

  //   return result.join("");
  // }

  return (
    <div className="rcDetailModal">
      <div className="rcDetailDiv">
        <p className="rcHeading">Registration No - </p>
        <p className="rcData">{RC_Data && RC_Data.Registration_Number}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Chassis No - </p>
        <p className="rcData">{RC_Data && RC_Data.ChassIs_No}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Owner Name - </p>
        <p className="rcData">{RC_Data && RC_Data.Vehicle_Owner}</p>

        {/* <p className="rcData">{RC_Data && replaceEvenPositionsWithX(RC_Data.Vehicle_Owner)}</p> */}
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Owner Permanent Address - </p>
        <p className="rcData">{RC_Data && RC_Data.Owner_Permanent_Address}</p>

        {/* <p className="rcData">{RC_Data && replaceEvenPositionsWithX(RC_Data.Owner_Permanent_Address)}</p> */}
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">RC Expiry Date - </p>
        <p className="rcData">{RC_Data && RC_Data.Expiry_Date}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">National Permit Expiry Date - </p>
        <p className="rcData">{RC_Data && RC_Data.Permit_Due_Date}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Permit Expiry Date - </p>
        <p className="rcData">{RC_Data && RC_Data.Permit_Due_Date}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">PUC Expiry Date - </p>
        <p className="rcData">{RC_Data && RC_Data.PUCC_Due_Date}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Vehicle Category - </p>
        <p className="rcData">{RC_Data && RC_Data?.Vehicle_Category}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Vehicle Fitness Expired - </p>
        <p className="rcData">{RC_Data && RC_Data.Vehicle_Fitness_Expired}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">National Permit No - </p>
        <p className="rcData">{RC_Data && RC_Data.Permit_Doc_No}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Vehicle Type - </p>
        <p className="rcData">{RC_Data && RC_Data.Vehicle_Type}</p>
      </div>
      <div className="rcDetailDiv">
        <p className="rcHeading">Vehicle Unloading Weight - </p>
        <p className="rcData">{RC_Data && RC_Data.Vehicle_Unladen_Weight}</p>
      </div>
      <EmtPortalFooter>
        <Button text="Ok" className={"acceptBtn"} type="button" name="modalbutton" action={onClose} />
      </EmtPortalFooter>
    </div>
  );
}

export default RCDetailsModal;
